module.exports = new __parcel__URL__("mining_not_enough_resources_dialog_got_it_button.c6b57100.png").toString();